<template>
    <v-row justify="center" class="linktree ml-1 mr-1">
      <v-col sm="12" md="12" lg="6">
        <h2 class="text-sm-body-2" v-if="instance.slug === 'osso'" v-html="'Bienvenidos a Osso / Welcome to Osso'" />
        <h2 class="text-sm-body-2" v-else>
          {{ $t("service.supplier.welcome_supplier_label", { name: instance.name }) }}
        </h2>
        <h3 class="text-sm-body-2" v-if="instance.slug !== 'osso'">
          <span v-if="service === 'on_table' && instance.labels_buttons.on_table.toString().length > 0" v-html="instance.labels_buttons.on_table" />
          <span v-if="service === 'on_table' && instance.labels_buttons.on_table.toString().length === 0">
            {{ $t("service.select_popup.on_table_title", { category: instance.category_establishment }) }}
          </span>
          <br />
          <span>{{ getLabels('change_branch_office') }}</span>
        </h3>
        <div v-if="ciudad.slug.length > 0">
          <v-btn
            v-for="item in suppliersFilter" :key="item.id"
            :class="['mt-2', item.slug]" block large
            v-html="item.label"
            @click="GoSupplier(item)"
            :data-testid="`CityBranchSuppliers-` + item.label"
          />
        </div>
        <v-btn
          v-if="ciudades.length > 1"
          class="mt-2 text-caption" block large
          @click="back()"
        >
          {{ $t("service.supplier.change_city_label") }} <br />
          <v-spacer />
          <small v-html="ciudad.label" />
        </v-btn>
      </v-col>
    </v-row>
</template>

<script>
import { mapState,mapActions,mapGetters } from "vuex";
export default {
  name: "CitysBranchSuppliers",
  props: {
    ciudad: Object,
    ciudades: Array,
    suppliers: Array
  },
  computed: {
    ...mapState('customer', ["instance"]),
    ...mapState('order', ["service"]),
    ...mapGetters('order', ["is_ontable_service","is_room_service","is_take_away_service","is_delivery_service"]),
    ...mapGetters('customer', ["is_ontable_no_incremental","is_ontable_checkout","is_ontable_plazoleta",'getLabels']),
    suppliersFilter() {
      return this.suppliers.filter(element => element.ciudad_obj === null || element.ciudad_obj.slug === this.ciudad.slug);
    }
  },
  created() {
    if (this.suppliersFilter.length === 1) this.GoSupplier(this.suppliersFilter[0]);
  },
  methods: {
    ...mapActions('customer', ["GetSupplier"]),
    back() {
      this.$emit('setCiudad', { id:'', slug:'' })
    },
    GoSupplier(supplier) {
      if (this.is_ontable_service && (this.is_ontable_plazoleta || !this.is_room_service)) this.goToOnTableHome(supplier);
      else if (this.is_room_service) this.goToOnServiceRoom(supplier);
      else if (this.is_delivery_service || this.is_take_away_service) this.goToDeliveryAndTakeAwayHome(supplier);
      else if (this.service === "book") this.goToBooking(supplier);
      else this.goToDeliveryAndTakeAwayHome(supplier);
    },
    goToOnTableHome (supplier) {
      if(this.instance.new_menu_v3){
        window.location.href ="/newmenu/"+supplier.id+"/on_table/basic";
      }else{
        this.$router.push({
          name: "OnTableMenuDigital",
          params: { supplier_id: supplier.slug }
        });
      }
    },
    goToOnServiceRoom (supplier) {
      this.$router.push({
        name: "ServiceRoom",
        params: { supplier_id: supplier.slug }
      });
    },
    goToDeliveryAndTakeAwayHome (supplier) {
      this.$router.push({
        name: "Home",
        params: { supplier_id: supplier.slug }
      });
    },
    goToBooking (supplier) {
      if(this.instance.new_reservations_v2){
        window.location.href = `/bookings/${supplier.id}`;
      }else{
        this.$router.push({
          name: "Book",
          params: { supplier_id: supplier.slug }
        });
      }
    }
  }
};
</script>
